import * as React from "react";
import Autocomplete from "react-autocomplete";
import { FieldProps, StateProps } from "./props";
import api from "../../../api";
import "./autocomplete.scss";
import noImage from "../../../assets/images/user-noimage.png";
import { Customer } from "../../../core";
import { isObject } from "util";
import { AvatarImage } from "../../render-file/AvatarImage";
import { UserAvatar } from "../../render-file/UserAvatar";
import { DebounceInput } from "react-debounce-input";

const AutoCompleteInput: React.FunctionComponent<FieldProps> = (props) => {
  const [list, setList] = React.useState<Customer[]>();
  const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
  const [showDropDown, setShowDropDown] = React.useState<boolean>(false);
  const [selectedItem, setSelectedItem] = React.useState<Customer | undefined>(
    props.defaultValue || undefined
  );

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!isLoaded) {
      loadData("");
    }
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  React.useEffect(() => {
    if (!isLoaded) {
      loadData("");
    }
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  React.useEffect(() => {
    const id = isObject(props.defaultValue)
      ? props.defaultValue?._id
      : props.defaultValue;
    if (id && id !== selectedItem?._id && !!list?.find((x) => x._id === id)) {
      setSelectedItem(list?.find((x) => x._id === id));
    }
    if (
      id &&
      id !== selectedItem?._id &&
      !list?.find((x) => x._id === id) &&
      isObject(props.defaultValue)
    ) {
      setSelectedItem(props.defaultValue);
    }
    if (!!props?.userReset) {
      setSelectedItem(undefined);
    }
  }, [props.defaultValue]);

  React.useEffect(() => {
    if (list && !!props.removeIds?.length) {
      setList(
        list?.filter(
          (x) => x._id && !props.removeIds?.includes(x._id?.toString())
        )
      );
    }
  }, [props.removeIds]);

  const loadData = async (query: string) => {
    setIsLoaded(true);

    const filter: any = {
      query,
      showroomId: props.showroomId,
      page: 1,
      perPage: 100,
    };

    if (props.hideBlocked) {
      filter.hideBlocked = true;
    }

    if (props.payload) {
      filter.payload = props.payload
    }

    const response = !!props.options?.length
      ? props.options
      : await (props.dataLoader?.(query) ??
          api.crud.searchCustomer(props.apiUrl, filter));
    let itemList = response;
    if (response && !!props.removeIds?.length) {
      itemList = response?.filter(
        (x) => x._id && !props.removeIds?.includes(x._id?.toString())
      );
    }
    setList(itemList);
  };

  const clickDropDown = () => {
    if (props.disabled) {
      return;
    }
    loadData("");
    setShowDropDown(!showDropDown);
  };

  const handleChange = (e: { target: any }) => {
    const { value } = e.target;

    loadData(value);
  };

  const handleSelect = (item: Customer) => {
    setList([item]);
    setSelectedItem(item);
    setShowDropDown(false);

    if (props.onChange != null) {
      props.onChange(item);
    }
  };

  const handleClickOutside = (event: { target: any }) => {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target)
    ) {
      setShowDropDown(false);
    }
  };

  return (
    <React.Fragment>
      {props.label && <label className={props.labelClass}>{props.label}</label>}
      <div className="custom-dropdown position-relative" ref={wrapperRef}>
        <div
          onClick={clickDropDown}
          className="custom-dropdown__value bg-gray-100 border rounded-sm font-normal d-flex align-items-center font-weight-semibold cursor-pointer"
        >
          <div
            className={`avatar-progress avatar-progress--xs position-relative cursor-pointer ${
              selectedItem && props.defaultValue && !props.loadingText
                ? ""
                : "avatar-progress--add"
            } ${props.isIconHidden === true ? "py-3" : ''}`}
          >
            {props.isIconHidden !== true && 
            <>
              <svg>
                <circle r="12" cx="50%" cy="50%" className="default"></circle>
                <circle
                  r="12"
                  cx="50%"
                  cy="50%"
                  className="progress"
                  stroke-dasharray="117"
                  stroke-dashoffset="45"
                ></circle>
              </svg>
              {selectedItem && props.defaultValue && !props.loadingText ? (
                <UserAvatar
                  id={selectedItem?._id}
                  className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
                  alt=""
                  title={selectedItem?.name}
                  imageUrl={selectedItem.photo?.location}
                  image={selectedItem.photo}
                ></UserAvatar>
              ) : (
                <div className="left-0 right-0 top-0 bottom-0 m-auto rounded-circle text-primary font-xs d-inline-flex justify-content-center align-items-center">
                  <i className="icon-plus"></i>
                </div>
              )}
            </>}
          </div>
          <div className="flex-fill text-truncate custom-dropdown__value-text">
            {props.loadingText ? (
              props.loadingText
            ) : (
              <>
                {selectedItem && props.defaultValue
                  ? selectedItem?.knownAs ||
                    selectedItem?.name ||
                    `${selectedItem?.firstName || ""} ${
                      selectedItem?.lastName || ""
                    }`
                  : props.customPlaceholder !== undefined ? props.customPlaceholder : `Add ${props.placeholder}`}
              </>
            )}
          </div>
          {(!selectedItem || !props.defaultValue || !props.onReset) && (
            <i className="icon-chevron-down ml-auto"></i>
          )}
          {selectedItem && props.defaultValue && props.onReset && (
            <i
              onClick={() => {
                setSelectedItem(undefined);
                props.onReset?.();
              }}
              className="icon-close ml-auto"
            ></i>
          )}
        </div>
        {showDropDown && !props.disabled && (
          <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100 position-absolute left-0 bg-white zIndex-9 pt-0">
            <div className="bg-white py-2 position-sticky top-0 zIndex-1">
              <div className="custom-dropdown__search border bg-gray-100 d-flex">
                <button
                  type="submit"
                  className="bg-transparent border-0 px-2 text-gray-600 d-flex align-items-center"
                >
                  <i className="icon-search"></i>
                </button>
                <DebounceInput
                  className="form-control bg-transparent border-0 py-0 px-1 font-weight-semibold font-normal"
                  minLength={2}
                  debounceTimeout={300}
                  onChange={handleChange}
                  // value={props.defaultValue ?? search}
                  onFocus={() => {
                    // if (search.length >= 3) {
                    setShowDropDown(true);
                    // }
                  }}
                  // placeholder={`Search a ${props.placeholder}`}
                  // ref={(input) => input && input.focus()}
                />
                {/* <input
                  type="text"
                  className="form-control bg-transparent border-0 py-0 px-1 font-weight-semibold font-normal"
                  placeholder={`Search a ${props.placeholder}`}
                  onChange={handleChange}
                  ref={(input) => input && input.focus()}
                /> */}
              </div>
            </div>
            {list?.map((item) => {
              return (
                <div
                  onClick={() => handleSelect(item)}
                  className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
                >
                  {props.isIconHidden !== true ? <div className="avatar-progress avatar-progress--xs position-relative cursor-pointer">
                    <svg>
                      <circle
                        r="12"
                        cx="50%"
                        cy="50%"
                        className="default"
                      ></circle>
                      <circle
                        r="12"
                        cx="50%"
                        cy="50%"
                        className="progress"
                        stroke-dasharray="117"
                        stroke-dashoffset="75"
                      ></circle>
                    </svg>
                    <UserAvatar
                      id={item?._id}
                      className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
                      alt=""
                      title={item?.name}
                      imageUrl={item.photo?.location}
                      image={item.photo}
                    ></UserAvatar>
                  </div> : null}
                  {item.name || item.knownAs ? (
                    <div className="font-normal font-weight-semibold">
                      {item.knownAs || item.name}
                    </div>
                  ) : (
                    <div className="font-normal font-weight-semibold">
                      {item?.firstName || ""} {item?.lastName || ""}
                    </div>
                  )}
                </div>
              );
            })}
            {props.addNew && (
              <div
                onClick={() => props.addNewItem?.()}
                className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
              >
                <i
                  className="font-xxs icon-plus mr-2 p-1 rounded-circle text-primary border border-primary border-width-2 font-weight-bold"
                  style={{ border: "2px solid #4161c8 !important" }}
                ></i>{" "}
                Add Customer
              </div>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default AutoCompleteInput;
